export default "__VITE_ASSET__DcaYvDTs__"